/**
 * Phase 66 Plan 02 — `useUser()` hook.
 *
 * Thin wrapper over AuthContext exposing the active user + a
 * permission-test helper. Pages call `useUser()` for the user object;
 * `<Can>` calls `useUser().can(permission)` for RBAC gating.
 */

import { useAuth } from "./AuthProvider";
import type { User } from "./AuthProvider";
import type { Permission } from "./permissions";

export type UseUserResult = User | null;

export function useUser(): UseUserResult {
  const { user } = useAuth();
  return user;
}

/**
 * Permission helper hook — returns `(perm) => boolean`. Computed once
 * per render from the AuthContext memoized permissions array.
 */
export function useCan(): (permission: Permission) => boolean {
  const { permissions } = useAuth();
  return (permission: Permission) => permissions.includes(permission);
}
